import React, { useEffect, useState } from 'react';
import { getAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';
import './CookieNotice.css';

export const OPEN_COOKIE_SETTINGS = 'olivia:open-cookie-settings';

const CookieNotice = () => {
  const [open, setOpen] = useState(() => getAnalyticsConsent() === null);

  useEffect(() => {
    const reopen = () => {
      setOpen(true);
    };
    window.addEventListener(OPEN_COOKIE_SETTINGS, reopen);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS, reopen);
  }, []);

  if (!open) return null;

  const decide = (granted) => {
    setAnalyticsConsent(granted);
    setOpen(false);
  };

  return (
    <section className="cookie" aria-label="Cookie notice">
      <div className="cookie__text">
        We use cookies to understand how people use our site and to improve it.{' '}
        <details className="cookie__more">
          <summary>Learn more</summary>
          <span>
            Pages viewed, approximate city, device and taps on WhatsApp, Call and Directions, processed
            by Google Analytics. We never see your name, phone number or messages.
          </span>
        </details>
      </div>
      <div className="cookie__actions">
        <button type="button" className="cookie__btn cookie__btn--accept" onClick={() => decide(true)}>
          Accept
        </button>
        <button type="button" className="cookie__btn" onClick={() => decide(false)}>
          Decline
        </button>
      </div>
    </section>
  );
};

export default CookieNotice;
